import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { TrophyIcon, UserCircleIcon } from '@heroicons/react/24/outline';

function Leaderboard() {
  const { user } = useAuth();

  // Mock leaderboard data
  const leaderboard = [
    { id: 1, name: 'Player 1', score: 1000, rank: 1 },
    { id: 2, name: 'Player 2', score: 800, rank: 2 },
    { id: 3, name: 'Player 3', score: 600, rank: 3 },
    { id: 4, name: 'Player 4', score: 400, rank: 4 },
    { id: 5, name: 'Player 5', score: 200, rank: 5 }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <div className="flex items-center space-x-4 mb-6">
          <div className="p-3 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
            <TrophyIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Leaderboard
            </h2>
            <p className="text-gray-500 dark:text-gray-400">
              Top players this week
            </p>
          </div>
        </div>

        <div className="space-y-4">
          {leaderboard.map((player) => (
            <div
              key={player.id}
              className={`flex items-center justify-between p-4 rounded-xl ${
                player.id === user?.id
                  ? 'bg-primary-50 dark:bg-primary-900/20'
                  : 'bg-gray-50 dark:bg-dark-700'
              }`}
            >
              <div className="flex items-center space-x-4">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 dark:bg-primary-900/20">
                  <span className="text-sm font-semibold text-primary-600 dark:text-primary-400">
                    {player.rank}
                  </span>
                </div>
                <div className="flex items-center space-x-2">
                  <UserCircleIcon className="h-6 w-6 text-gray-400" />
                  <span className="font-medium text-gray-900 dark:text-white">
                    {player.name}
                  </span>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <TrophyIcon className="h-5 w-5 text-yellow-500" />
                <span className="font-semibold text-gray-900 dark:text-white">
                  {player.score}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* User's Rank */}
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Your Rank
        </h3>
        <div className="flex items-center justify-between p-4 bg-primary-50 dark:bg-primary-900/20 rounded-xl">
          <div className="flex items-center space-x-4">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 dark:bg-primary-900/20">
              <span className="text-sm font-semibold text-primary-600 dark:text-primary-400">
                {user?.rank || 'N/A'}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <UserCircleIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
              <span className="font-medium text-gray-900 dark:text-white">
                {user?.displayName || 'You'}
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <TrophyIcon className="h-5 w-5 text-yellow-500" />
            <span className="font-semibold text-gray-900 dark:text-white">
              {user?.score || 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard; 